import { render } from "./App.vue?vue&type=template&id=6155abb4"
const script = {}

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__